import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { Typography, Collapse } from '@material-ui/core';
import { makeStyles, fade } from '@material-ui/core/styles';
import InputCard from './InputCard';

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '280px',
    marginTop: theme.spacing(1),
    // margin: '0 auto',
  },
  addCard: {
    padding: theme.spacing(1, 1, 1, 2),
    margin: theme.spacing(0, 1, 1, 1),
    backgroundColor: '#EBECF0',
    '&:hover': {
      backgroundColor: fade('#000', 0.25),
    },
  },
  spacing: {
    padding: theme.spacing(0.5),
  },
}));

export default function AddCard({ type, listId }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleInputCard = () => {
    setOpen(true);
  };
  const handleCloseInputCard = () => {
    setOpen(false);
  };
  return (
    <div className={classes.root}>
      <Collapse in={open}>
        <InputCard
          handleClose={handleCloseInputCard}
          type={type}
          listId={listId}
        />
      </Collapse>
      <Collapse in={!open}>
        <Paper
          className={classes.addCard}
          elevation={0}
          onClick={handleInputCard}
        >
          <Typography>
            {type === 'card' ? '+ Add a Card' : '+ Add another List'}
          </Typography>
        </Paper>
      </Collapse>

      <div className={classes.spacing}></div>
    </div>
  );
}
